import React from "react";
import { Table, Pagination, CircularProgress } from "@ann/web-components";
import Filters from "../Filters";
import Icon from "../../../../../../../../../elements/icon/Icon";
import { 
  TableWrapper, 
  TableContainer, 
  PaginationWrapper, 
  LoadingContainer, 
  NoDataWrapper, 
  NoDataTitle, 
  NoDataDescription 
} from "./ActivityLogTableSection.styled";

const ActivityLogTableSection = ({
  tableData,
  headers,
  currentPage,
  itemsPerPage,
  onItemsPerPageChange,
  onPageChange,
  totalItems,
  totalPages,
  loading,
  onSortChange,
  onOrderChange,
  selectedSortOption,
  orderDirection,
  onSearchChange,
  onActionChange,
}) => {
  const showEmptyState = !loading && tableData.length === 0;

  return (
    <TableWrapper>
      <TableContainer>
        <Filters
          onSortChange={onSortChange}
          onOrderChange={onOrderChange}
          selectedSortOption={selectedSortOption}
          orderDirection={orderDirection}
          onSearchChange={onSearchChange}
          onActionChange={onActionChange}
          loading={loading}
        />
        {loading ? (
          <LoadingContainer>
            <CircularProgress size="xl" />
          </LoadingContainer>
        ) : showEmptyState ? (
          <NoDataWrapper>
            <Icon name="noDataAvailable" width="201px" height="195px" />
            <NoDataTitle>No activity yet</NoDataTitle>
            <NoDataDescription>
              No activity logs found.
            </NoDataDescription>
          </NoDataWrapper>
        ) : (
          <Table
            data={tableData}
            headers={headers}
            mode="table"
            showActions={false}
          />
        )}
      </TableContainer>
      {!showEmptyState && (
        <PaginationWrapper>
          <Pagination
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={onItemsPerPageChange}
            onPageChange={onPageChange}
            totalItems={totalItems}
            totalPages={totalPages}
            disabled={loading}
          />
        </PaginationWrapper>
      )}
    </TableWrapper>
  );
};

export default ActivityLogTableSection;

